import React from 'react'
import PropTypes from 'prop-types'
import Button, { TYPES } from '../Button/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import Link from '../Link/index'

export const MESSAGE_TYPES = {
  TEAL: 'TEAL',
  PINK: 'PINK',
}

/**
 * @returns {JSX.Element} Highlight Message
 */
function HighlightMessage (props) {
  const {
    className,
    type,
    title,
    content,
    buttonText,
    buttonOnClick,
    buttonURL,
    imgUrl,
    imgLink,
    onImgLinkClick,
  } = props

  return <div className={`highlight-message highlight-message--${type.toLowerCase()}${className ? ` ${className}` : ''}`}>
    { imgUrl && (
      <div className="highlight-message__image-container">
        {
          imgLink
            ? <Link to={imgLink} className="highlight-message__image" style={{ backgroundImage: `url(${imgUrl})` }} onClick={onImgLinkClick}></Link>
            : <div className="highlight-message__image" style={{ backgroundImage: `url(${imgUrl})` }}></div>
        }
      </div>
    )}
    <div className="highlight-message__body">
      { title && <div className="highlight-message__title">{ title }</div> }
      <div className="highlight-message__content">{ content }</div>
      {
        buttonText && buttonURL && (
          <Button
            url={buttonURL}
            onClick={buttonOnClick}
            type={TYPES.SECONDARY}
            className="highlight-message__button"
          >
            <>
              {buttonText}
              <IconV2
                className="highlight-message__button-icon"
                type={ICON_TYPES.CHEVRON_RIGHT}
              />
            </>
          </Button>
        )
      }
    </div>
  </div>
}

HighlightMessage.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node.isRequired,
  className: PropTypes.string,
  buttonURL: PropTypes.string,
  buttonText: PropTypes.string,
  buttonOnClick: PropTypes.func,
  imgUrl: PropTypes.string,
  type: PropTypes.oneOf([
    MESSAGE_TYPES.TEAL,
    MESSAGE_TYPES.PINK,
  ]),
}

HighlightMessage.defaultProps = {
  type: MESSAGE_TYPES.TEAL,
  imgLinkOnClick: () => {},
  buttonOnClick: () => {},
}

export default HighlightMessage
